import useDriftAccountStore from 'src/stores/useDriftAccountsStore';

export const useBalanceCount = () => {
	const balanceCount = useDriftAccountStore((s) => {
		const currentAccountKey = s.currentUserKey;
		return s.accounts[currentAccountKey ?? '']?.balanceCount ?? 0;
	});
	return balanceCount;
};
